import { put, remove, get } from "./apiClient";

export default {
  async getShifts(facilityId) {
    if (!facilityId) {
      throw new Error("Facility ID is required");
    }

    return await get(`facility/${encodeURIComponent(facilityId)}/shifts`);
  },

  async updateShifts(facilityId, shifts) {
    return await put(
      `facility/${encodeURIComponent(facilityId)}/shifts`,
      shifts
    );
  },

  async deleteShift(shiftId) {
    await remove(`shifts/${encodeURIComponent(shiftId)}`);
  }
};
